angular.module('dpw.services').factory('appIconService',
    ['$q', 'api', function ($q, api) {

        var placeholder = '/assets/images/image_placeholder.svg';

        var validImageMimeType = ['image/jpeg', 'image/png', 'image/gif', 'image/svg+xml'];
        var validImageMimeTypeWithoutSvg = ['image/jpeg', 'image/png', 'image/gif'];

        var errorTypes = {
            INVALID_EXT: 'INVALID_EXT',
            INVALID_EXT_WITHOUT_SVG: 'INVALID_EXT_WITHOUT_SVG',
            NOT_IMAGE: 'NOT_IMAGE',
            NOT_SQUARE: 'NOT_SQUARE',
            INVALID_FILE_SIZE: 'INVALID_FILE_SIZE'
        };

        var errorMessageMapping = {
            'INVALID_EXT': 'Please upload a jpg/png/svg/gif image.',
            'INVALID_EXT_WITHOUT_SVG': 'Please upload a jpg/png/gif image.',
            'NOT_IMAGE': 'The file you are trying to upload is not a supported image type.',
            'NOT_SQUARE': 'Image must be a square.',
            'INVALID_FILE_SIZE': 'Image size must be less than 2MB.'
        };

        function isValid(file, isSupportSvg) {
            return $q.resolve()
                .then(function () {
                    return isValidImageExt(file, isSupportSvg);
                })
                .then(function (isValid) {
                    if (isValid) {
                        return isImage(file);
                    }
                    var errorType = isSupportSvg
                        ? errorTypes.INVALID_EXT
                        : errorTypes.INVALID_EXT_WITHOUT_SVG;
                    return $q.reject(errorType);
                })
                .then(function (isValid) {
                    if (isValid) {
                        return isSquare(file);
                    }
                    return $q.reject(errorTypes.NOT_IMAGE);
                })
                .then(function (isValid) {
                    if (isValid) {
                        return isValidFileSize(file);
                    }
                    return $q.reject(errorTypes.NOT_SQUARE);
                })
                .then(function (isValid) {
                    if (isValid) {
                        return $q.resolve();
                    }
                    return $q.reject(errorTypes.INVALID_FILE_SIZE);
                });
        }

        function upload(appId, file) {
            return $q(function (resolve) {
                api.call(api.admin.applications.uploadIcon(appId, file), function (result) {
                    resolve(result.url);
                });
            });
        }

        function isImage(file) {
            return $q(function (resolve) {
                var reader = new FileReader();
                reader.readAsDataURL(file);

                reader.onload = function (e) {
                    var image = new Image();
                    image.onload = function () {
                        resolve(true);
                    };

                    image.onerror = function () {
                        resolve(false);
                    };

                    image.src = e.target.result;
                };
            });
        }

        function isSquare(file) {
            return $q(function (resolve) {
                var reader = new FileReader();
                reader.readAsDataURL(file);

                reader.onload = function (e) {
                    var image = new Image();
                    image.onload = function () {
                        var isSquareImage = image.height === image.width;
                        resolve(isSquareImage);
                    };

                    image.src = e.target.result;
                };
            });
        }

        function isValidImageExt(file, isSupportSvg) {
            var type = _.get(file, 'type', '');
            return _.includes(getValidImageMimeType(isSupportSvg), type);
        }

        function isValidFileSize(file) {
            var maxSize = 2 * 1024 * 1024;
            var size = _.get(file, 'size', 0);
            return size > 0 && size <= maxSize;
        }

        function getValidImageMimeType(isSupportSvg) {
            return isSupportSvg ? validImageMimeType : validImageMimeTypeWithoutSvg;
        }

        return {
            isValid: isValid,
            upload: upload,
            getValidImageMimeType: getValidImageMimeType,
            placeholder: placeholder,
            validImageMimeType: validImageMimeType,
            errorMessageMapping: errorMessageMapping
        };
    }]);
